import { Type } from 'class-transformer';
import { Model } from './model';
import { Organization } from './organization';
import { LinkedIntegration } from './linked_integration';

export class Channel extends Model {
  id: string;

  is_private: boolean;

  name: string;

  @Type(() => LinkedIntegration)
  linked_integration: LinkedIntegration;

  organization_id: string;

  @Type(() => Organization)
  organization: Organization;

  remote_id: string;
}
